import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { catalogBibShape } from '@bibliocommons/bc-prop-types';
import { selectSummariesTransactions } from 'app/selectors/ugc/SummariesSelector';
import SummariesActions from 'app/actions/SummariesActions';
import ModalActions from 'app/actions/ModalActions';
import { getIsLoadingFromUgcTransactions } from 'app/helpers/bib/bibHelpers';
import DeleteSummaryModal from './DeleteSummaryModal';

export class DeleteSummaryModalContainer extends React.PureComponent {
  render() {
    return <DeleteSummaryModal {...this.props} />;
  }
}

DeleteSummaryModalContainer.propTypes = {
  // ownProps
  summaryId: PropTypes.number.isRequired,
  catalogBib: catalogBibShape.isRequired,
  handleSuccess: PropTypes.func,

  // Redux props
  summariesActions: PropTypes.objectOf(PropTypes.func).isRequired,
  isLoading: PropTypes.bool.isRequired,
  modalActions: PropTypes.objectOf(PropTypes.func).isRequired
};

const mapStateToProps = (state, ownProps) => ({
  isLoading: getIsLoadingFromUgcTransactions(
    selectSummariesTransactions(state),
    ownProps.catalogBib.get('metadataId'),
    ownProps.summaryId
  )
});

const mapDispatchToProps = dispatch => ({
  summariesActions: bindActionCreators(SummariesActions, dispatch),
  modalActions: bindActionCreators(ModalActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(DeleteSummaryModalContainer);
